import { MemreFlexBox, MemreLayout, MemreSection, MemreSectionHeading } from 'components/core';
import { useLocation } from 'react-router-dom';
import { queryParams } from 'utils/pathUtils';
import { AuthoringContextProvider } from './AuthoringContext';
import { useAuthoringContext } from './AuthoringContext';
import AuthoringHeading from './components/AuthoringHeading';
import AuthorItems from './components/AuthorItems';
import { CautionTape } from './components/CautionTape';
import PreviewButton from './components/PreviewButton';
import StudiableStatus from './components/StudiableStatus';
import FreeResponses from './interactions/FreeResponses';
import InstructionalContent from './interactions/InstructionalContent';
import MultipleChoiceQuestion from './interactions/MultiplechoiceQuestion';
import NoInteraction from './interactions/NoInteraction';
import Ratings from './interactions/Ratings';
import Regions from './interactions/Regions';
import Sequence from './interactions/Sequence';
import SurveyQuestionAndAnswers from './interactions/SurveyQuestionAndAnswers';
import Flashcards from './interactions/Flashcards';
import Vocabulary from './interactions/Vocabulary';

function AuthoringPage() {
  const { item, courseId } = useAuthoringContext();
  const location = useLocation();
  
  // Check if the current URL contains a course (e.g., /nav/courses/123/sets/456/items)
  // vs the direct set URL (e.g., /nav/sets/456/items)
  const hasCourseInUrl = location.pathname.includes('/courses/');
  const defaultBackLink = hasCourseInUrl ? `/nav/courses/${courseId}` : '/nav/content';
  const backLink = (queryParams(location).returnUrl as string)?.replace(/^\/app/, '') || defaultBackLink;

  const EditArea: JSX.Element | undefined = item ? (
    {
      question_and_answers: <MultipleChoiceQuestion key={item?.id} />,
      sequences: <Sequence key={item?.id} />,
      regions: <Regions key={item?.id} />,
      instructional_contents: <InstructionalContent key={item?.id} />,
      free_responses: <FreeResponses key={item?.id} />,
      survey_question_and_answers: <SurveyQuestionAndAnswers key={item?.id} />,
      ratings: <Ratings key={item?.id} />,
      associations: <Flashcards key={item?.id} />,
      vocabulary: <Vocabulary key={item?.id} />,
    }[item?.templateType]
  ) : (
    <NoInteraction />
  );

  return (
    <MemreLayout headerText="Editing Assignment" isLoading={false} backLink={backLink}>
      <MemreFlexBox direction="column" gap={2}>
        <MemreSection>
          <MemreSectionHeading text={<AuthoringHeading />} cta={<PreviewButton />} />
          <MemreFlexBox direction="row" gap={2} sx={{ minHeight: '600px' }}>
            <AuthorItems />
            <MemreFlexBox direction="column" gap={1} sx={{ flex: 1, marginRight: '15px', marginTop: '10px' }}>
              <CautionTape />
              {item && <StudiableStatus />}
              {EditArea}
            </MemreFlexBox>
          </MemreFlexBox>
        </MemreSection>
      </MemreFlexBox>
    </MemreLayout>
  );
}

export default function AuthoringPageWrapper(props) {
  const { setId, courseId } = props.match.params;
  const location = useLocation();
  const params = queryParams(location);
  const initialItemId = params.itemId as string | undefined;
  return (
    <AuthoringContextProvider setId={setId} courseId={courseId} initialItemId={initialItemId}>
      <AuthoringPage />
    </AuthoringContextProvider>
  );
}
